import { createAction } from "redux-actions";
import { createSelector } from "reselect";
import { path, pathOr, prop } from "ramda";

export const SET_RESIZABLE_WIDTH = "DOMAIN@CONTENT/SET::RESIZABLE_WIDTH";

export const setResizableWidth = createAction(SET_RESIZABLE_WIDTH);

const getContent = path(["domain", "ui", "content"]);

export const selectResizableWidth = createSelector(
  getContent,
  prop("resizableWidth")
);

const initialState = () => ({
  resizableWidth: pathOr(
    "80%",
    ["book", "ui", "dls", "teacherColumnWidth"],
    window.getClientConfiguration()
  )
});

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_RESIZABLE_WIDTH:
      return { ...state, resizableWidth: action.payload };
    default:
      return state;
  }
}
